<template>
  <ContainerCard id="filtroContasBancarias" icon="fa-filter" title="Selecione as opções de pesquisa.">
      <b-card><!-- FILTROS -->
          <el-form class="geral-form" ref="formFiltroContasBancarias" :model="modelFiltro" :rules="rules" size="small" label-position="top">
              <el-row :gutter="20">
                  
                  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                      <el-form-item label="Grupo" prop="grupo" v-loading="loadGrupos">
                          <el-select class="w-100" size="small" v-model="modelFiltro.grupo" filterable clearable :placeholder="`Selecione um grupo`">
                              <el-option
                              v-for="item in listaGrupos"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                      <el-form-item label="Nome Conta" prop="nome">
                        <el-input class="w-100" size="small" v-model="modelFiltro.nome"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>
          </el-form>
          
          <div slot="footer">
              <div class="float-left btn-pesquisar" >
                  <el-button size="small" @click.prevent="pesquisar" type="primary" icon="el-icon-search">Pesquisar</el-button> 
                  <el-button size="small" @click.prevent="limparFiltros" icon="el-icon-brush">Limpar</el-button> 
              </div>
              <el-button class="float-right" :loading="loadingExportar" size="small" type="success" icon="el-icon-download" @click="requestExportarContasBancarias">Exportar para Excel </el-button>
          </div>
      </b-card>
  </ContainerCard>
</template>

<script>
import ContainerCard from '@/components/shared/ContainerCard'
export default {
  components: {
    ContainerCard
  },
  data() {
    return {
      loadGrupos: false,
      loadingExportar: false,
      listaGrupos: [],
      modelFiltro: {
        grupo: '',
        nome: ''
      },
      rules: {
        grupo: [
          { required: false, message: 'Por favor, escolha um grupo', trigger: ['change','blur'] }
        ]
      }
    }
  },
  methods: {
    async getGrupos() { // grupos
      this.loadGrupos = true

      try {
          const response = await this.axios.get(this.$urls.GRUPOS)
          
          if(response.status !== 200) {
              throw new Error('Erro ao carregar lista de Clientes')
          }

          this.listaGrupos = response.data
      } catch(err) {
          console.error(err)
      } finally {
          this.loadGrupos = false
      }
    },
    pesquisar() {
      const ctx = this

      ctx.$refs['formFiltroContasBancarias'].validate((valid) => {
          if (!valid) {
          ctx.$notify.error({
            title: 'Validação',
            message: `Por favor, preencha todos os campos obrigatórios`,
            position:'top-left'
          });
          return
        }

          ctx.pesquisarGet()
      });
    },
    pesquisarGet() {

      const params = {
          grupos: this.modelFiltro.grupo,
          nomeConta: this.modelFiltro.nome
      }

      // Emitindo os filtros para o componente pai
      this.$emit('filtrar', params);

    },
    exportar() {
      console.log('Exportar')
    },
    async requestExportarContasBancarias() {
      const params = new URLSearchParams({
        grupos: this.modelFiltro.grupo || '',
        nomeConta: this.modelFiltro.nome || '',
      });

      const urlComParametros = `${this.$urls.EXPORTAR_CONTAS_VINCULADAS}?${params.toString()}`;

      this.loadingExportar = true

      try {
        this.$blob.getDownload(urlComParametros);
      } catch (error) {
        console.error('Erro na solicitação de download:', error);
        throw error;
      } finally {
        this.loadingExportar = false;
      }
    },
    limparFiltros() {
      this.modelFiltro.grupo = ''
      this.modelFiltro.nome = ''
      this.modelFiltro.inicioFim = []

      this.$refs['formFiltroContasBancarias'].clearValidate();
    },
  },
  mounted() {
    this.getGrupos()
  }
}
</script>

<style>

</style>
